/** Tasdiq so'rovi o'ng tugma menyusi: kutilayotgan/hal qilinganiga va turiga qarab (test: menu.test.ts). */
import { Check, Copy, ExternalLink, Eye, Phone, Wallet, X } from "lucide-react";
import { compactMenu, SEPARATOR, type MenuEntry } from "@/components/ui/context-menu";
import type { Translate } from "@/features/drivers/menu";
import type { Approval } from "./types";
import { profileItem, type ProfileAction } from "@/features/people/profileAction";
import type { Permission } from "@/features/auth/types";

export interface ApprovalMenuActions {
  approve: () => void;
  reject: () => void;
  navigate: (path: string) => void;
  openNewTab: (path: string) => void;
  call: (phone: string) => void;
  copy: (text: string) => void;
  profile?: ProfileAction;
  /** Budjet havolasi: xarajat -- "budget", bonus -- "pay" ruxsati bo'lsa */
  can: (perm: Permission) => boolean;
}

const BUDGET_PATH: Record<string, { path: string; perm: Permission }> = { expense: { path: "/budget/expenses", perm: "budget" }, bonus: { path: "/budget/bonuses", perm: "pay" } };

export function approvalMenu(a: Approval, act: ApprovalMenuActions, t: Translate): MenuEntry[] {
  const pending = a.status === "pending";
  const d = a.driver_info;
  const budget = BUDGET_PATH[a.kind] && act.can(BUDGET_PATH[a.kind].perm) ? BUDGET_PATH[a.kind].path : undefined;
  return compactMenu([
    pending && { key: "approve", label: t("approval.approve"), icon: Check, onSelect: act.approve },
    pending && { key: "reject", label: t("approval.reject"), icon: X, onSelect: act.reject },
    SEPARATOR,
    !!d && { key: "open-driver", label: t("openDriver", { name: d.full_name }), icon: Eye, onSelect: () => act.navigate(`/drivers/${d.id}`) },
    !!d && { key: "open-tab", label: t("openNewTab"), icon: ExternalLink, onSelect: () => act.openNewTab(`/drivers/${d.id}`) },
    !!d?.phone && { key: "call", label: t("call"), icon: Phone, hint: d.phone, onSelect: () => act.call(d.phone) },
    !!d?.phone && { key: "copy-phone", label: t("copyPhone"), icon: Copy, onSelect: () => act.copy(d.phone) },
    profileItem(act.profile, a.requested_by?.id, t, { name: a.requested_by?.display_name, key: "requester-profile" }),
    !!budget && { key: "budget", label: t("approval.openBudget"), icon: Wallet, onSelect: () => act.navigate(budget) },
    SEPARATOR,
    !!a.summary && { key: "copy-summary", label: t("approval.copySummary"), icon: Copy, onSelect: () => act.copy(a.summary) },
  ]);
}
